import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class QuestionnaireItemWidgetProps extends BackboneElement {
    static __className = 'WidgetProps';

    __objectStructure = {
        editDemographics: Boolean,
        diagnosisDisplayCriteria: Boolean,
        defaultDiagnosisStatus: String,
        defaultProblemStatus: String,
        problemList: Boolean,
        dobRequired: Boolean,
        addressRequired: Boolean,
        showAllActiveRelease: Boolean,
        allowAssessment: Boolean,
        allowReassessment: Boolean,
        treatmentPlanMedsOnly: Boolean,
        requireVitalsSet: Boolean,
        // The Vitals widget's history range in days (30, 60 or 90). Unset shows only the note's own sets.
        vitalsHistoryDays: Number,
    };

    constructor(constructJson, className = 'WidgetProps') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }

    /**
     * Clears any String widget prop whose current value is an empty string.
     * The primitive setter coerces '' -> undefined, so the key is dropped from
     * toJSON(). Boolean props (e.g. false) are left untouched.
     */
    clearEmptyValues() {
        for (const [key, type] of Object.entries(this.__objectStructure)) {
            if (type === String && this[key] === '') {
                this[key] = undefined;
            }
        }
    }
}
